import React from 'react';

const MembershipBadge = ({ planId, planName, userType = 'creator' }) => {
  // Don't show badge if no plan
  if (!planId || !planName) return null;
  
  // Define colors, emojis and styles for each tier
  const getStylesAndEmoji = () => {
    const baseStyle = {
      padding: '6px 10px',
      borderRadius: '6px',
      fontFamily: "'Neue Einstellung', 'Poppins', sans-serif",
      fontSize: '12px',
      fontWeight: '600',
      textTransform: 'uppercase',
      letterSpacing: '0.5px',
      display: 'inline-flex',
      alignItems: 'center',
      gap: '6px',
      border: '1.5px solid',
      backgroundColor: 'transparent'
    };
    
    if (userType === 'creator') {
      // Creator tiers with outlined style
      if (planId.includes('now_boarding')) {
        return {
          style: {
            ...baseStyle,
            borderColor: '#0f084b', // Navy
            color: '#0f084b',
          },
          emoji: '✈️' // Airplane for Now Boarding
        };
      } else if (planId.includes('in_flight')) {
        return {
          style: {
            ...baseStyle,
            borderColor: '#dc1d08', // Red
            color: '#dc1d08',
          },
          emoji: '🚀' // Rocket for In Flight
        };
      } else if (planId.includes('flight_crew')) {
        return {
          style: {
            ...baseStyle,
            borderColor: '#B8860B', // Dark gold
            color: '#B8860B',
          },
          emoji: '⭐' // Star for Flight Crew
        };
      } else if (planId.includes('first_class')) {
        return {
          style: {
            ...baseStyle,
            borderColor: '#DAA520', // Gold
            color: '#000000',
            backgroundColor: '#FFF9E6' // Light gold background
          },
          emoji: '👑' // Crown for First Class
        };
      }
    } else if (userType === 'host') {
      // Host tiers with outlined style
      if (planId.includes('round_trip')) {
        return {
          style: {
            ...baseStyle,
            borderColor: '#0f084b', // Navy
            color: '#0f084b',
          },
          emoji: '🛫' // Plane for Round Trip
        };
      } else if (planId.includes('passport')) {
        return {
          style: {
            ...baseStyle,
            borderColor: '#dc1d08', // Red
            color: '#dc1d08',
          },
          emoji: '🌍' // Globe for Passport
        };
      } else if (planId.includes('visa')) {
        return {
          style: {
            ...baseStyle,
            borderColor: '#B8860B', // Gold
            color: '#B8860B',
          },
          emoji: '🏆' // Trophy for Visa
        };
      }
    }
    
    // Default style if plan not recognized
    return {
      style: {
        ...baseStyle,
        borderColor: '#E6E8EC',
        color: '#23262F',
      },
      emoji: '✨'
    };
  };
  
  // Get display name (remove underscores and parentheses from plan name)
  const getDisplayName = () => {
    if (!planName) return '';
    
    // Extract just the tier name (e.g., "Now Boarding (Yearly)" -> "Now Boarding")
    const match = planName.match(/^([^(]+)/);
    if (match) {
      return match[1].trim();
    }
    
    // Fallback - replace underscores with spaces
    return planName.replace(/_/g, ' ').replace(/\s+\(.*\)/, '');
  };
  
  const { style, emoji } = getStylesAndEmoji();
  const displayName = getDisplayName();
  
  return (
    <span style={style}>
      <span style={{ fontSize: '14px' }}>{emoji}</span>
      {displayName}
    </span>
  );
};

export default MembershipBadge;
